import { Component, type ErrorInfo, type ReactNode } from 'react';

interface IErrorBoundaryComponentProps {
	children: ReactNode;
}

interface IErrorBoundaryComponentState {
	error: Error | null;
}

/** Without this, any render-time throw in the route tree unmounts the whole app to a blank page with no on-screen signal. */
export class ErrorBoundaryComponent extends Component<
	IErrorBoundaryComponentProps,
	IErrorBoundaryComponentState
> {
	state: IErrorBoundaryComponentState = { error: null };

	static getDerivedStateFromError(error: Error) {
		return { error };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('Admin app crashed:', error, info.componentStack);
	}

	render() {
		if (this.state.error) {
			return (
				<div className="flex min-h-svh flex-col items-center justify-center gap-3 bg-paper font-grotesk p-6 text-center">
					<p className="text-lg font-semibold text-ink">
						Something went wrong.
					</p>
					<pre className="max-w-xl overflow-auto rounded-2xl border border-rule bg-panel p-4 text-left text-xs whitespace-pre-wrap text-danger">
						{this.state.error.message}
						{'\n\n'}
						{this.state.error.stack}
					</pre>
				</div>
			);
		}

		return this.props.children;
	}
}
